import DialogView from '../../dialog/Dialog.view.tsx';
import { useTranslation } from 'react-i18next';
import styles from './UserMarketsDialog.desktop.module.css';
import React from 'react';
import MultiSelectView from '../../../components/multi-select/MultiSelect.view.tsx';
import LoaderView from '../../../components/loader/Loader.view.tsx';
import type UserMarketsDialogProperties from '../UserMarketsDialog.properties.ts';
import { useUserMarketsDialogController } from '../UserMarketsDialog.controller.ts';

export default function UserMarketsDialogDesktopView(props: UserMarketsDialogProperties) {
  const { t } = useTranslation();
  const {
    loading,
    selectedMarkets,
    prepareMarketsForSmartSelect,
    handleSave,
    handleMarketsChange,
  } = useUserMarketsDialogController(props);

  return (
    <DialogView header={t('ui.userMarketDialogHeader')} onBackdrop={props.handleDialogCloseClick}>
      <div>
        <>
          {loading && <LoaderView />}

          {!loading && (
            <>
              <table className={styles.table}>
                <tbody>
                  <tr>
                    <td className={styles.tdKey}>{t('ui.markets')}</td>
                    <td className={styles.tdValue}>
                      <MultiSelectView
                        selectedValues={selectedMarkets}
                        data={prepareMarketsForSmartSelect() ?? []}
                        handleChange={handleMarketsChange}
                        width="270px"
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <div className={styles.buttonContainer}>
                <button className={styles.buttonSave} onClick={handleSave}>
                  {t('ui.save')}
                </button>
              </div>
            </>
          )}
        </>
      </div>
    </DialogView>
  );
}
